import { FC } from 'react'
import { Modal } from 'react-bootstrap'
import { FilterReportBookingTypeForm } from './FilterReportBookingTypeForm'
import { FilterReportBookingTypeModalHeader } from './FilterReportBookingTypeModalHeader'

type Props = {
  show: boolean
  closeModal: () => void
}

const FilterReportBookingTypeModal: FC<Props> = ({show, closeModal}) => {
  return (
    <>
      <Modal className='modal fade' dialogClassName='modal-xl' show={show} onHide={closeModal}>
        <div className='modal-content'>
          <FilterReportBookingTypeModalHeader closeModal={closeModal} />
          <div className='modal-body scroll-y'>
            <FilterReportBookingTypeForm closeModal={closeModal} />
          </div>
        </div>
      </Modal>
    </>
  )
}

export { FilterReportBookingTypeModal }

